import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fold",
  "use": "icon-fold-usage",
  "viewBox": "0 0 1137 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1137 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fold\"><path d=\"M1137.777778 0H0v204.8h1137.777778V0z m0 409.6H379.278222v204.8H1137.777778V409.6z m0 409.6H0V1024h1137.777778v-204.8z m-853.333334-512L0 512l284.444444 204.8V307.2z\" p-id=\"2849\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol